import {combineReducers} from 'redux';

import env from './env';

import {reducer as api} from '../api';
import {reducer as flows} from '../flows';
import {reducer as session} from '../flows/session/reducer';

export default (key, routerReducer, envData, apollo) => combineReducers({
  [key]: routerReducer,
  session,
  data: api,
  flows,
  env: env(envData),
  apollo,
});



// WEBPACK FOOTER //
// ./mobile/shared/reducers/index.js